import { Brain, Building2, MessageSquare, PhoneCall } from "lucide-react";
import { debriefElapsedLabel, debriefMeetingTimeLabel } from "./debrief";
import type { DebriefReminder, RealEstateCase } from "./types";

type DebriefGateCardProps = {
  caseItem: RealEstateCase;
  reminder: DebriefReminder;
  now: Date;
  detail?: boolean;
  onStart: (caseId: string, reminderId: string) => void;
  onSnooze: (caseId: string, reminderId: string, minutes: number) => void;
  onNotRequired: (caseId: string, reminderId: string) => void;
};

export function DebriefGateCard({
  caseItem,
  reminder,
  now,
  detail = false,
  onStart,
  onSnooze,
  onNotRequired
}: DebriefGateCardProps) {
  return (
    <article className={`debrief-task${detail ? " case-debrief-gate" : ""}`}>
      <div className="debrief-task-meta">
        <Brain size={detail ? 21 : 18} aria-hidden="true" />
        <div>
          <strong>{detail ? caseItem.contactName : caseItem.propertyAddress || caseItem.contactName}</strong>
          <span>{detail ? reminder.eventLabel : `${caseItem.contactName} · ${reminder.eventLabel}`}</span>
          <span>{debriefMeetingTimeLabel(reminder.startAt, now)}{detail ? "" : ` · ${debriefElapsedLabel(reminder.endAt, now)}`}</span>
          <em>{reminder.status === "review" ? "Čaká na potvrdenie" : reminder.status === "analyzing" ? "Analyzuje sa" : "Debrief chýba"}</em>
          {reminder.endTimeInferred ? <small>Koniec vypočítaný z predvolenej dĺžky</small> : null}
        </div>
      </div>
      <p>{detail ? "Sprav debrief a urči ďalší krok." : <>Sprav si analýzu stretnutia, kým máš detaily čerstvé.<br />2 minúty teraz = lepší follow-up a lepší obchod.</>}</p>
      <button className="primary-button full-button" type="button" onClick={() => onStart(caseItem.id, reminder.id)}>
        <Brain size={17} aria-hidden="true" /> Spraviť debrief
      </button>
      <div className="debrief-secondary-actions">
        <button type="button" onClick={() => onSnooze(caseItem.id, reminder.id, 15)}>Odložiť o 15 min</button>
        <button type="button" onClick={() => onSnooze(caseItem.id, reminder.id, 60)}>Odložiť o 1 hodinu</button>
        <button type="button" onClick={() => onNotRequired(caseItem.id, reminder.id)}>Stretnutie neprebehlo</button>
      </div>
    </article>
  );
}

export function CaseDebriefGateScreen(props: DebriefGateCardProps) {
  const { caseItem } = props;

  return (
    <section className="case-debrief-entry" aria-labelledby="case-debrief-entry-title">
      <header className="case-debrief-entry-heading">
        <p className="eyebrow">Povinný krok</p>
        <h1 id="case-debrief-entry-title">DOKONČI STRETNUTIE</h1>
        <p>Stretnutie – čaká na debrief</p>
      </header>

      <DebriefGateCard {...props} detail />

      <aside className="case-debrief-context" aria-label="Údaje prípadu">
        <div>
          <Building2 size={17} aria-hidden="true" />
          <span>{caseItem.propertyAddress || caseItem.propertyType}</span>
        </div>
        <div className="case-debrief-contact-actions">
          <a href={`tel:${caseItem.phone}`}>
            <PhoneCall size={16} aria-hidden="true" /> Zavolať
          </a>
          <a href={`sms:${caseItem.phone}`}>
            <MessageSquare size={16} aria-hidden="true" /> SMS
          </a>
        </div>
      </aside>
    </section>
  );
}
